import gql from 'graphql-tag'

export const CANCEL_GIVING_SUBSCRIPTION_MUTATION = gql`
  mutation cancelGivingSubscription($id: ID!) {
    cancelGivingSubscription(id: $id) {
      errors
    }
  }
`
